import axios from '@ts/utils/axios';
import { ApiRequestError } from '@ts/utils/errors';

export const fetch = (params, rest = {}) =>
    axios.get('/destination/new', { params, ...rest }).then(({ data }) => {
        if (data && Array.isArray(data.items)) {
            return data.items;
        }

        throw new ApiRequestError('Failed fetch destinations /destination/new', { params, rest });
    });

export const fetchPopular = (params, rest = {}) =>
    axios.get('/destination/popular', { params, ...rest }).then(({ data }) => {
        if (data && Array.isArray(data.items)) {
            return data.items;
        }

        throw new ApiRequestError('Failed fetch destinations /destination/new', { params, rest });
    });

export function fetchById(id, rest = {}) {
    return axios.get(`/destination/${id}`, rest).then(({ data }) => {
        if (data && typeof data === 'object' && data.id) {
            return data;
        }

        throw new ApiRequestError(`Failed fetchById destinations /destination/${id}`, {
            id,
            rest,
        });
    });
}
